const prod_configs = {
  COGNITO_USERPOOL : 'us-west-2_OV06mpINa',
  COGNITO_CLIENT : '1sobr0cf08onvk1gs6fn9bqoi4',
  COGNITO_IDENTITY_POOL : 'us-west-2:545583fb-ffa4-436f-a26c-5a9dd1327a2f',
  REGION: 'us-west-2',
  HOST : 'https://api.adlooker.com'
}

export default prod_configs;
